module.exports = __webpack_public_path__ + "img/img_005.5459a47c.png";